import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import './mapModeChip.css';

/**
 * Phone-only arm/disarm for reading parcel ownership.
 *
 * Keeps three concerns apart. The Parcels toggle only draws boundaries, so
 * they stay usable as a tracing guide. The map canvas belongs to the geo
 * tools. Identify is its own mode: while armed, a tap resolves to the parcel
 * underneath instead of to a saved feature, and pan and pinch still work.
 *
 * Named after the GIS "Identify" tool so it does not collide with parcel
 * selection, which is the separate mode for building a boundary from lots.
 */
export function ParcelIdentifyControl({ show, active, onToggle }) {
  if (!show) return null;

  return (
    <button
      type="button"
      className={`map-mode-chip parcel-identify-control${
        active ? ' map-mode-chip--active parcel-identify-control--active' : ''
      }`}
      onClick={onToggle}
      aria-pressed={active}
      aria-label={active ? 'Exit parcel info mode' : 'Parcel info mode'}
      title={active ? 'Exit parcel info mode' : 'Tap a parcel for owner info'}
      data-testid="parcel-identify-control"
    >
      <FaInfoCircle aria-hidden="true" />
      <span className="map-mode-chip__label">
        {active ? 'Tap a parcel' : 'Parcel info'}
      </span>
    </button>
  );
}
